<template>
	<main>
		<div class="container">
			<div class="title-container">
				<h2>Nos points de vente</h2>
				<p>Acheter nos huîtres en boutique</p>
			</div>
			<section>
				<ul class="shop__list">
					<li class="item">
						<div class="item__image-container">
							<img src="@/assets/shop/logo_lfb.webp" alt="https://lafamilleboutrais.com">
						</div>
						<div class="item__meta">
							<h3>Bretagne Huître Production</h3>
							<p>Les Nielles Bâtiment 6,<br> 35350 St Méloir des ondes</p>
							<p>Ouvert du Lundi au Vendredi 7:00 à 17:00</p>
							<button aria-label="go" type="button" class="button full">J'y vais !</button>
						</div>
					</li>
					<li class="item">
						<div class="item__image-container">
							<img src="https://picsum.photos/seed/picsum/500/300" alt="#">
						</div>
						<div class="item__meta">
							<h3>Marché de St Servan</h3>
							<p>3 Pl. Bouvet,<br> 35400 Saint-Malo</p>
							<p>Mardi et Vendredi de 08h00 à 13h00</p>
							<button aria-label="go" type="button" class="button full">J'y vais !</button>
						</div>
					</li>
					<li class="item">
						<div class="item__image-container">
							<img src="https://picsum.photos/seed/picsum/500/300" alt="#">
						</div>
						<div class="item__meta">
							<h3>Marché de Rocabey</h3>
							<p>Place des Halles,<br> 35400 St Malo</p>
							<p>Jeudi et Samedi de 8h30-13h00</p>
							<button aria-label="go" type="button" class="button full">J'y vais !</button>
						</div>
					</li>
				</ul>

				<!-- TODO Google Map -->
				<div id="map">
					<iframe src="https://www.openstreetmap.org/export/embed.html?bbox=-2.287559509277344%2C48.52206208716404%2C-1.7142105102539065%2C48.72041422804209&amp;layer=mapnik"></iframe>
				</div>

			</section>
		</div>
	</main>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
	name: "PointsOfSales",
  beforeMount () {
    this.$store.dispatch('metaData/getMetaData', 17)
  },
  computed: {
    ...mapGetters('metaData', ['getMeta']),
  },
  metaInfo() {
    return {
      title: this.getMeta.template,
      meta:[
        // meta données générales
        {  name: 'title', content: this.getMeta.meta_title},
        { name: 'description', content: this.getMeta.meta_desc},
        { name: 'robots', content: 'index,follow'},
        // pour SEO FB et Linkedin
        { property: 'og:type', content:"website"},
        { property: 'og:url', content: "https://lafamilleboutrais.com/"},
        { property: 'og:title', content: this.getMeta.meta_title},
        { property: 'og:description', content: this.getMeta.meta_desc},
        // { property: 'og:image', content: this.getCategory.image },
      ],
    }
  },
	mounted() {
		const headerHeight = document.querySelector('header').offsetHeight
		const map = document.querySelector('#map')
		map.style.top = `${headerHeight + 10}px`
	},
  methods: {
    ...mapActions('metaData', ['getMetaData']),
  },
}
</script>

<style lang="scss" scoped>
.container {
	@include flex(flex-start, flex-start, column, $gap: 20px);
	position: relative;
	width: 90vw;
	max-width: 1200px;
	margin: 0 auto;
	@media screen and (min-width: 992px) {
		width: 90vw;
	}
	@media screen and (min-width: 1200px) {
		width: 80vw;
	}
}

.title-container {
	width: 100%;
	text-align: center;
	margin: 50px 0 45px;

	@media screen and (min-width: 992px) {
		margin: 50px 0 75px;
	}

	h2 {
		color: $LightBrown;
		font-size: 35px;

		@media screen and (min-width: 768px) {
			font-size: 45px;
		}

		@media screen and (min-width: 992px) {
			font-size: 56px;
		}
	}
}

section {
	@include flex(space-between, center, column-reverse, $gap: 50px);
	width: 100%;
	@media screen and (min-width: 992px) {
		flex-direction: row;
		align-items: flex-start;
	}

	.shop__list {
		@include flex(flex-start, flex-start, column);
		flex: 1;

		.item {
			@include flex(space-between, center, column, $gap: 10px);
			@media screen and (min-width: 992px) {
				flex-direction: row;
				gap: 50px;
			}

			&:not(:last-child) {
				border-bottom: 1px solid $Grey;
				padding-bottom: 25px;
			}

			&:not(:first-child) {
				padding-top: 25px;
			}

			&__image-container {
				@include flex(center, center);
				flex: 1;
				border-radius: 10px;
				overflow: hidden;
				position: relative;
				height: 100%;

				img {
					width: 100%;
					object-fit: cover;
				}
			}

			&__meta {
				@include flex(center, center, column, $gap: 5px);
				flex: 1;
				text-align: center;
				padding: 5px 0;

				@media screen and (min-width: 992px) {
					gap: 3px
				}

				button {
					margin-top: 10px;
					@media screen and (min-width: 992px) {
						margin-top: 5px;
					}
				}
			}
		}
	}

	#map {
		@include flex(center, center);
		flex: 1;
		position: initial;
		height: 40vh;
		min-height: 40vh;
		width: 100%;

		@media screen and (min-width: 992px) {
			@include position(0, 0, $position: sticky);
			height: 400px;
			min-height: unset;
		}

		iframe {
			width: 100%;
			height: 100%;
			min-height: 40vh;
			border: 0;

			@media screen and (min-width: 992px) {
				min-height: unset;
			}
		}
	}
}

</style>